import { render, staticRenderFns } from "./UrunResimCellRenderer.vue?vue&type=template&id=5f1ded39&"
import script from "./UrunResimCellRenderer.vue?vue&type=script&lang=js&"
export * from "./UrunResimCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports